import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/welcome/page'));
const Question1Page = lazy(() => import('../pages/question1/page'));
const Question2Page = lazy(() => import('../pages/question2/page'));
const Question3Page = lazy(() => import('../pages/question3/page'));
const PositiveResultPage = lazy(() => import('../pages/positive-result/page'));
const NegativeResultPage = lazy(() => import('../pages/negative-result/page'));
const TesekkurlerPage = lazy(() => import('../pages/tesekkurler/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/soru-1',
    element: <Question1Page />,
  },
  {
    path: '/soru-2',
    element: <Question2Page />,
  },
  {
    path: '/soru-3',
    element: <Question3Page />,
  },
  {
    path: '/sonuc-olumlu',
    element: <PositiveResultPage />,
  },
  {
    path: '/sonuc-olumsuz',
    element: <NegativeResultPage />,
  },
  {
    path: '/tesekkurler',
    element: <TesekkurlerPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
